import axios from 'axios';
import { isDevEnv } from 'src/utils/isDevEnv';
import {
  prefixPath,
  appModeUuid,
  defaultLanguage,
} from 'src/utils/capabilities';
import { getBaseUrl } from 'src/utils/getConfig';
import {
  FORBIDDEN_PAGE_URL,
  UNAUTHORIZED_PAGE_URL,
} from 'src/constants/urlConstants';

const baseUrl = getBaseUrl();
const servicePath = prefixPath === '/' ? '' : prefixPath;

const axiosInstance = axios.create({
  baseURL: isDevEnv() ? '' : servicePath,
  headers: {
    'x-applicationmode': appModeUuid,
    'x-language': defaultLanguage,
  },
});

axiosInstance.interceptors.request.use(
  config => config,
  error => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  config => config,
  error => {
    if (error?.response?.status === 403) {
      window.location.assign(`${baseUrl}${FORBIDDEN_PAGE_URL}`);
      return Promise.reject(error);
    }
    if (error?.response?.status === 401) {
      return window.location.assign(`${baseUrl}${UNAUTHORIZED_PAGE_URL}`);
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
